// extracted by mini-css-extract-plugin
export default {"cve":"cve-module--cve--17WK6","header":"cve-module--header--3FzxZ","subHeading":"cve-module--subHeading--CwX9e","heading":"cve-module--heading--32y21"};